import { render, staticRenderFns } from "./director.vue?vue&type=template&id=105d6d0b"
import script from "./director.vue?vue&type=script&lang=js"
export * from "./director.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports